module.exports = __webpack_public_path__ + "static/lifestyle4-43db4031a0155a941f0ae63e2081dcbe.jpg";